/**
 * Subtle background column pattern used in all marketing page hero areas.
 * Matches v1 MarketingHeader's BackgroundVector SVG — 5 trapezoid columns
 * with a very subtle white gradient fill.
 */
export function MarketingBackgroundVector() {
  return (
    <svg
      className="mk-bg-vector"
      width="1400"
      height="946"
      viewBox="0 0 1400 946"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="bgVectorGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.32)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0.16)" />
        </linearGradient>
      </defs>
      <path d="M664 1134.54L107.62 0H-62L644.2 1134.54H664Z" fill="url(#bgVectorGrad)" />
      <path d="M736.6 1134.54L1292.98 0H1462.6L756.4 1134.54H736.6Z" fill="url(#bgVectorGrad)" />
      <path d="M675.221 1134.54L309.581 0H471.281L684.461 1134.54H675.221Z" fill="url(#bgVectorGrad)" />
      <path d="M741.879 1134.54L1107.52 0H945.819L732.639 1134.54H741.879Z" fill="url(#bgVectorGrad)" />
      <path d="M695.02 1133.88L620.44 0H790.06L714.16 1133.88H695.02Z" fill="url(#bgVectorGrad)" />
    </svg>
  )
}
